// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__c5IF0","title":"CardHeader_title__2jLGo"};